import { getRenderer } from '@bridebook/ui';

/**
 * FelaProvider renderer for coupleside.
 * Used in _app.tsx for client-side rendering and in _document.tsx for server-side rendering.
 */
export const webFelaRenderer = getRenderer({
  withLegacyDefaultStyles: false,
});
